export const filterSecureFilesByQuery = (files, searchQuery) => {
  const query = (searchQuery || "").trim().toLowerCase();
  if (!query) {
    return files;
  }

  return files.filter((file) => {
    const searchableText = [file.fileName, file.uploadedByName, file.uploadedAtLabel]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchableText.includes(query);
  });
};
